module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (191).4ac2d539.jpg";